import findInTree from "./findInTree";
export default function getSelectedItem(_ref) {
  var selectedItem = _ref.selectedItem,
      selectedValue = _ref.selectedValue,
      items = _ref.items,
      toValue = _ref.toValue;

  if (selectedItem) {
    return selectedItem;
  }

  if (!selectedValue) {
    return null;
  }

  return findInTree(items, function (item) {
    return toValue(item) === selectedValue;
  });
}